export default {
  SHORT: 'short',
  MEDIUM: 'medium',
} as const;
